module.exports = __webpack_public_path__ + "static/media/azure-contracting.b81d3e11.png";